import { gql } from "@apollo/client";

export const GET_RATE_CARDS = gql`
  query rateCards {
    rateCards {
      id
      name
      isActive
      isDefault
      displayName
      dateUpdated
      lastUpdatedBy {
        firstName
        lastName
      }
      businessCustomers {
        businessCustomer {
          businessName
          id
        }
        autoIncrementRatesBy
        increaseRatesYearly
      }
      vehicleGroups {
        name
        unlimitedMileage
        mileageLimit
        pricePerExtraMile
        pricing {
          rangeStart
          rangeEnd
          unitPrice
        }
        vehicleGroup {
          id
          name
        }
      }
    }
  }
`;
